module.exports = __webpack_public_path__ + "static/media/circo_2015_logo.8459a529.png";